import { z } from 'my-zod'

export const notificationAddressFragment = z.object({
  id: z.string().uuid(),
  addressLine1: z.string(),
  addressLine2: z.string().nullish(),
  city: z.string(),
  postalCode: z.string(),
  stateProvince: z.string(),
  country: z.string(),
  attention: z
    .object({
      firstName: z.string(),
      lastName: z.string(),
      email: z.string().email(),
      businessPhone: z.string().nullable(),
      mobilePhone: z.string().nullable()
    })
    .nullish()
})

export type notificationAddressFragment = z.infer<typeof notificationAddressFragment>
